'use strict';

var React = require('react'),
    StampDraftStore = require('../stores/StampDraftStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    Button = require('../atoms/Button'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    DraftPageControls = require('./DraftPageControls'),
    { PropTypes } = React;

var DraftComposePageControls = React.createClass({
  mixins: [createStoreMixin(StampDraftStore), PureRenderMixin],

  propTypes: {
    stampSegment: PropTypes.string.isRequired
  },

  getStateFromStores() {
    return {
      isUnlisted: StampDraftStore.isUnlisted(),
      isPublishing: StampDraftStore.isPublishing(),
      canPublish: StampDraftStore.canPublish()
    };
  },

  render() {
    const { stampSegment } = this.props;
    const { isPublishing, canPublish, isUnlisted } = this.state;

    return (
      <DraftPageControls showOptions
                         {...{ isPublishing, canPublish, stampSegment, isUnlisted }}>
        <Button onClick={this.handlePreviewClick}
                context='PageControls'
                size='medium'
                overlay
                color='black'>
          Preview
        </Button>
      </DraftPageControls>
    );
  },

  handlePreviewClick() {
    DraftActionCreators.switchToPreview();
  }
});

module.exports = DraftComposePageControls;



/** WEBPACK FOOTER **
 ** ./pageControls/DraftComposePageControls.jsx
 **/